import { useEffect, useState } from "react"
import { Outlet } from "react-router-dom"
import { NavigationComponent } from "../navigation"
import { getUnreadCount } from "../../services/notification-service"
import { WelcomeModal } from "../welcomeModal"

export const MainLayout = () => {
    const [menuOpen, setMenuOpen] = useState(false)
    const [unreadCount, setUnreadCount] = useState(0)

    useEffect(() => {
        const fetch = () => getUnreadCount().then((r) => setUnreadCount(r.count)).catch(() => {})
        fetch()
        const interval = setInterval(fetch, 30000)
        return () => clearInterval(interval)
    }, [])

    return (
        <div className="main-layout">
            <WelcomeModal />
            <div className="main-layout-shell">
                <aside className="main-layout-sidebar">
                    <NavigationComponent />
                </aside>

                {menuOpen && (
                    <div
                        className="mobile-menu-overlay"
                        onClick={() => setMenuOpen(false)}
                    >
                        <div
                            className="mobile-menu-drawer"
                            onClick={(e) => e.stopPropagation()}
                        >
                            <NavigationComponent
                                mobile
                                onNavigate={() => setMenuOpen(false)}
                            />
                        </div>
                    </div>
                )}

                <main className="main-layout-content">
                    <div className="mobile-topbar">
                        <button
                            type="button"
                            className="mobile-menu-button relative"
                            onClick={() => setMenuOpen(true)}
                            aria-label="Open menu"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="22"
                                height="22"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                                strokeWidth="2"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            </svg>
                            {unreadCount > 0 && (
                                <span className="absolute -top-1 -right-1 flex h-[18px] min-w-[18px] items-center justify-center rounded-full bg-figmaContrast px-1 text-[10px] font-bold text-white leading-none">
                                    {unreadCount > 9 ? "9+" : unreadCount}
                                </span>
                            )}
                        </button>

                        <img
                            src="/images/jobbin-logo-with-icon.png"
                            alt="Jobbin"
                            className="mobile-topbar-logo"
                        />

                        <div style={{ width: 42 }} />
                    </div>

                    <div className="main-layout-page" style={{ padding: 0 }}>
                        <Outlet />
                    </div>
                </main>
            </div>
        </div>
    )
}